import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, LogoutOutlined, DownOutlined, UngroupOutlined, RobotOutlined } from "@ant-design/icons";
import { Button, Col, Layout, Row, Typography, Avatar, Space, Dropdown, Modal, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import samurdhiLogo from '../Assets/samurdhi-logo-2.png';
import './Customheader.css';
import { logout } from "../Components/Login/loginservice";
import { errHandler, logouSuccess, success } from "../helper/helper";
import ThemeSwitcher from "../Utils/ThemeSwitcher";
import { useAuth } from "../Auth/AuthProvider";

const { Header } = Layout;
const { Text } = Typography;

function CustomHeader({ onButtonClick }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [buttonClicked, setButtonClicked] = useState(true);
    const [modalVisible, setModalVisible] = useState(false); // State for modal visibility
    const name = localStorage.getItem("user");
    const branchName = localStorage.getItem("branch") !== "undefined" ? localStorage.getItem("branch") : " ";

    const content = (
        <>
            <div style={{ height: "20px", fontSize: "16px" }}>{name}</div>
            <div style={{ height: "40px", padding: "0", fontSize: "12px" }}>{branchName}</div>
        </>
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleClick = () => {
        setButtonClicked(!buttonClicked);
        onButtonClick(!buttonClicked);
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { logout } = useAuth(); // get logout from context


    const handleLogout = async () => {
        try {
            await fetch('/logout', {
                method: 'GET',
                credentials: 'include',
            });
            logout()
            navigate("/");
            logouSuccess();
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const items = [
        {
            label: (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <ThemeSwitcher />
                </div>
            ),
            key: '0',
        },
        {
            label: (
                <a target="_blank" rel="noopener noreferrer">
                    {branchName}
                </a>
            ),
            key: '1',
            icon: <UngroupOutlined />,
        },
        {
            label: (
                <a target="_blank" rel="noopener noreferrer">
                    {name}
                </a>
            ),
            key: '2',
            icon: <UserOutlined />,
        },
        {
            label: (
                <a target="_blank" rel="noopener noreferrer">
                    logout
                </a>
            ),
            key: '3',
            onClick: handleLogout,
            icon: <LogoutOutlined />,
        }
    ];

    const handleHome = () => {
        navigate('/master/home');
    };

    // Function to handle ChatGPT icon click
    const handleChatGPTClick = () => {
        setModalVisible(true); // Show the modal
    };

    const handleModalCancel = () => {
        setModalVisible(false); // Hide the modal
    };

    // Form submission handler
    const onFinish = (values) => {
        console.log('Form values:', values);
        // Handle form submission (e.g., send to API)
        handleModalCancel(); // Close modal after submission
    };

    return (
        <>
            <Header className="site-layout-header">
                <Row align="middle" justify="space-between" style={{ width: "100%" }}>
                    <Col style={{ justifyContent: "start" }}>
                        <Row>
                            <div onClick={handleHome} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                <img src={samurdhiLogo} alt="logo" className="samurdhi-image" style={{ marginLeft: -40, marginTop: 10, marginBottom: 10 }} />
                                <h2 className="welcome-note" style={{ marginTop: 15, marginLeft: 10, color: "grey" }}>MIS PANEL</h2>
                            </div>
                        </Row>
                    </Col>

                    <Col>
                        <div className="avatar-container">
                            <Row align="middle">
                                <Col>
                                    <Space direction="horizontal" size={16}>
                                        <div style={{ border: '1px solid grey', height: 60, marginTop: 20, marginBottom: 1, marginRight: 50 }}></div>
                                        <div style={{ display: "flex", height: "80px" }}>
                                            <div style={{ color: "grey", padding: "0px", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column" }}>
                                                <div style={{ color: "grey", padding: "0px", position: "relative" }}>
                                                    {content}
                                                </div>
                                            </div>
                                            <div style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                                                <Avatar size="large" icon={<UserOutlined style={{ color: "grey" }} />} />
                                            </div>
                                        </div>
                                    </Space>
                                </Col>

                                <Col style={{ alignItems: "center", marginTop: -10 }}>
                                    <Space direction={"horizontal"} size={18}>
                                        <Dropdown menu={{ items }}>
                                            <a onClick={(e) => e.preventDefault()}>
                                                <Space style={{ color: 'grey', width: '10px' }}>
                                                    <DownOutlined />
                                                </Space>
                                            </a>
                                        </Dropdown>


                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Header>

            {/* ChatGPT Modal */}
            <Modal
                title="Copilot Form"
                visible={modalVisible}
                onCancel={handleModalCancel}
                footer={null} // No footer buttons
            >
                <Form
                    name="chatgpt_form"
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Form.Item
                        label="Your Message"
                        name="message"
                        rules={[{ required: true, message: 'Please input your message!' }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export default CustomHeader;
